























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class TablePagination extends Vue {
  // Props
  @Prop()
  perPage!: number
  @Prop()
  currentPage!: number
  @Prop()
  numofPage!: number

  @Prop()
  limitedPagination!: boolean

  perPageVal: number = 0
  currentPageVal: number = 0

  @Watch('perPageVal')
  @Watch('currentPageVal')
  perPageValChanged() {
    this.$emit('update:perPage', this.perPageVal)
    this.$emit('update:currentPage', this.currentPageVal)
    this.$emit('pageSeleted', 'change')
  }

  created() {
    this.perPageVal = this.perPage
    this.currentPageVal = this.currentPage
  }
}
